const React = require('react');
const FieldC = require('../../../../dumb/Field/C');

module.exports = ({description}) => (
  <div>
    <FieldC
      label="Reference"
      value={description}
    />
  </div>
);
